import * as React from "react";

import { List, TextField, FunctionField } from "jazasoft";

import { isEmpty } from "../../../utils/helpers";
import { useSetting, useUnit } from "../../../hooks";
import SettingKeys from "../../../utils/SettingKeys";
import { Entity } from "../../../utils/types";
import Datagrid from "../../../components/Datagrid";
import TooltipTextField from "../../../components/TooltipTextField";
import { LotType } from "../../../constants";

const FabricRelease = props => {
  const orderFields = useSetting(SettingKeys.ENTITY_FIELDS, Entity.ORDERS);
  const orderFlowFields = useSetting(SettingKeys.ENTITY_FIELDS, Entity.ORDER_FLOW);

  const { allUnitList } = useUnit();

  return (
    <List
      searchKeys={["order.poRef", "order.customerPoRef", "fpo", "styles", "flowRefs", "customerFlowRefs"]}
      actions={({ resource }) => <div>{/* <FilterButton showLabel={false} resource={resource} /> */}</div>}
      {...props}
      i18nKey="fab-release">
      <Datagrid rowClick="view">
        {orderFields.includes("poRef") && <TooltipTextField source="poRef" length={20} />}
        {orderFields.includes("customerPoRef") && <TooltipTextField source="customerPoRef" length={20} />}
        {orderFlowFields.includes("unitId") && (
          <TooltipTextField
            source="unitId"
            render={record => (!isEmpty(record?.unitId) ? allUnitList.find(e => e.unitId === record.unitId)?.name : "-")}
            length={20}
          />
        )}
        {orderFlowFields.includes("fpo") && <TooltipTextField source="fpo" length={20} />}
        {orderFlowFields.includes("flowRefs") && <TooltipTextField source="flowRefs" length={20} />}
        {orderFlowFields.includes("customerFlowRefs") && <TooltipTextField source="customerFlowRefs" length={20} />}
        {orderFields.includes("customer") && <TooltipTextField source="customer" length={20} />}
        {orderFlowFields.includes("productName") && (
          <FunctionField source="productName" render={record => (isEmpty(record?.productName) ? "-" : record.productName)} />
        )}
        {orderFlowFields.includes("styles") && <TooltipTextField source="styles" length={20} />}
        {orderFlowFields.includes("colors") && <TooltipTextField source="colors" length={20} />}
        {orderFlowFields.includes("inseams") && <TooltipTextField source="inseams" length={20} />}
        {orderFlowFields.includes("part") && <TextField source="part" />}
        {orderFlowFields.includes("destinations") && <TooltipTextField source="destinations" length={20} />}
        {orderFlowFields.includes("deliveries") && <TooltipTextField source="deliveries" length={20} />}
        {orderFlowFields.includes("lotValue") && (
          <FunctionField
            source="lotValue"
            render={record =>
              record?.lotType === LotType.BULK ? `Lot ${record.lot}` : !isEmpty(record?.lotType) ? `${record.lotType} ${record.lot}` : "-"
            }
          />
        )}
      </Datagrid>
    </List>
  );
};

export default FabricRelease;
